import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {transition, trigger, useAnimation} from '@angular/animations';
import {fadeInDown} from 'ng-animate';
import {ApirequestService} from '../../../../services/apirequest/apirequest.service';
import {ApiurlsService} from '../../../../services/api-urls/apiurls.service';
import {UtilityService} from '../../../../services/utilities/utilities.services';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastsManager} from 'ng2-toastr';
import {OrderPipe} from 'ngx-order-pipe';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BlurInputErrorMatcher} from '../../../../modules/material/material.errror';
import {isArray} from 'util';
import {k} from '@angular/core/src/render3';

@Component({
  selector: 'hybse-admin-affiliate-add',
  templateUrl: './addaffiliate.component.html',
  styleUrls: ['./addaffiliate.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown, {
      params: {
        timing: 1,
        a: '-10px'
      }
    }))])
  ]
})
export class AddaffiliateComponent implements OnInit {
  public affiliateForm: FormGroup;
  public affiliateList: any = [];
  public showLoader: boolean = true;
  fadeInDown: any;
  private idAffiliate: number;
  public errorMessage: string;
  public pageTitle: string;
  public affiliateData: any = {
    referrer: 0,
    username: null,
    internalAddress: null,
    email: null,
    firstName: null,
    lastName: null,
    dateofBirth: null,
    country: null,
    address: null,
    nationality: null,
    altEmail: null,
    phone1: null,
    phone2: null,
    btcAddress: null,
    Bank: null,
    IBAN: null,
    SWIFT: null,
    products: false,
    productsdm: false,
    productsdm2: false,
    commissionPay: 1
  };
  public affPackage = {
    blockshare: false,
    bitcoin: false,
    stablecoin: false
  };
  public commPayout: string[] = [];
  public blurMatcher = new BlurInputErrorMatcher();
  public types: object[] = [{
    label: 'Currency',
    value: 'Primary'
  }, {
    label: 'Stock',
    value: 'Secondary'
  }];
  public status: object[] = [{
    label: 'Enabled',
    value: 'enabled'
  }, {
    label: 'Disabled',
    value: 'disabled'
  }];
  public btcEnabled: object[] = [{
    label: 'Yes',
    value: 1
  }, {
    label: 'No',
    value: 0
  }];

  constructor(public _api: ApirequestService,
              public _urls: ApiurlsService,
              public _utils: UtilityService,
              public router: Router,
              public toastr: ToastsManager, vcs: ViewContainerRef,
              private activatedRoute: ActivatedRoute,
              private orderPipe: OrderPipe,
              public _fb: FormBuilder) {
    this.toastr.setRootViewContainerRef(vcs);
  }

  getAffiliateList() {
    const data = {};
    this._api.fetchApiData(this._urls.affiliateListUrl, data).subscribe(
      (res: any) => {
        const response = res.data;
        const errRes = res.error;

        if (response) {
          this.affiliateList = response.affilifateList;

          this.getAffiliateDetails();
        } else {
          this.errorMessage = errRes['Error Description'];
          this.showLoader = false;
        }
      },
      error => {},
      () => {}
    );
  }

  getAffiliateDetails() {
    if (typeof this.idAffiliate !== 'undefined') {
      const data = { idAffiliate: this.idAffiliate };

      this._api.fetchApiData(this._urls.affiliateDetailUrl, data).subscribe(
        (res: any) => {
          const response = res.data;
          const errRes = res.error;

          if (response) {
            this.mapData(response);
            // this.affiliateData = response;
            this.setCheckboxes(response.products);
          } else {
            this.errorMessage = errRes['errorDescription'];
          }
        },
        error => {
          this.showLoader = false;
        },
        () => {
          this.showLoader = false;
        }
      );
    } else {
      this.showLoader = false;
    }
  }

  private mapData(data) {
      for (const key in data) {
        switch (key) {
          case 'internaladdress':
            this.affiliateData.internalAddress = data[key];
            break;
          case 'firstname':
            this.affiliateData.firstName = data[key];
            break;
          case 'lastname':
            this.affiliateData.lastName = data[key];
            break;
          case 'dateofbirth':
            this.affiliateData.dateofBirth = data[key];
            break;
          case 'altemail':
            this.affiliateData.altEmail = data[key];
            break;
          case 'btcaddress':
            this.affiliateData.btcAddress = data[key];
            break;
          case 'iban':
            this.affiliateData.IBAN = data[key];
            break;
          case 'swift':
            this.affiliateData.SWIFT = data[key];
            break;
          case 'bank':
            this.affiliateData.Bank = data[key];
            break;
          case 'commissionpay':
            this.affiliateData.commissionPay = data[key];
            break;
          default:
            this.affiliateData[key] = data[key];
        }
      }
  }

  buildForm() {
    this.affiliateForm = this._fb.group({
      referrer: [0, Validators.required],
      username: [null, Validators.required],
      internalAddress: [null],
      email: [null, Validators.required],
      firstName: [null, Validators.required],
      lastName: [null, Validators.required],
      dateofBirth: [null, Validators.required],
      country: [null, Validators.required],
      address: [null, Validators.required],
      nationality: [null, Validators.required],
      altEmail: [null],
      phone1: [null, Validators.required],
      phone2: [null],
      btcAddress: [null, Validators.required],
      Bank: [null],
      IBAN: [null],
      SWIFT: [null],
      products: [false],
      productsdm: [false],
      productsdm2: [false],
      commissionPay: [1, Validators.required]
    }, {validator: this.productValidate});
  }

  public productValidate(formGroup): any {
    if (formGroup.controls['products'].value || formGroup.controls['productsdm'].value || formGroup.controls['productsdm2'].value) {
      return true;
    } else {
      return { productValid: false };
    }
  }

  private setCheckboxes(data) {
    const dArr = data.split(',');

    for (const el in dArr) {
      if (dArr[el] === 'Blockshare') {
        this.affPackage.blockshare = true;
      } else if (dArr[el] === 'Stablecoin') {
        this.affPackage.stablecoin = true;
      } else if (dArr[el] === 'Bitcoin') {
        this.affPackage.bitcoin = true;
      }
    }
  }

  onClick(action: string): void {
    if (action === 'submit') {

      this.showLoader = true;
      const formData = this.affiliateForm.value;
      let product = '';

      delete formData.productsdm;
      delete formData.productsdm2;

      if (this.affPackage.blockshare) {
        product = product + 'Blockshare,';
      }
      if (this.affPackage.stablecoin) {
        product = product + 'Stablecoin,';
      }
      if (this.affPackage.bitcoin) {
        product = product + 'Bitcoin,';
      }

      formData.products = product;

      if (typeof this.idAffiliate === 'undefined') {
        this._api.fetchApiData(this._urls.affiliateCraeteUrl, formData).subscribe(
          (res: any) => {},
          error => {
            this.showLoader = false;
          },
          () => {
            this.showLoader = false;
            this.router.navigate(['/affiliate/list']);
          }
        );
      } else {
        formData.idAffiliate = this.idAffiliate;

        this._api.fetchApiData(this._urls.affiliateUpdateUrl, formData).subscribe(
          (res: any) => {},
          error => {
            this.showLoader = false;
          },
          () => {
            this.showLoader = false;
            this.router.navigate(['/affiliate/list']);
          }
        );
      }
    } else {
      this.router.navigate(['/affiliate/list']);
    }
  }

  private initCommissionPayArray() {
    this.commPayout[1] = 'Payment of the full commission in BEX Blockshares';
    this.commPayout[2] = 'Payment of the full commission in Bitcoin';
    this.commPayout[3] = 'Payment of the full commission in FIAT currency';
    this.commPayout[4] = 'Payment of 50% of the commission in BEX Blockshares and 50% in Bitcoin';
    this.commPayout[5] = 'Payment of 50% of the commission in FIAT currency and 50% in BEX Blockshares';
    this.commPayout[6] = 'Payment of 50% of the commission in FIAT currency and 50% in Bitcoin';
  }

  ngOnInit() {
    this.initCommissionPayArray();
    this.activatedRoute.params.subscribe( param => {
      this.idAffiliate = param.idAffiliate;
    });

    if (typeof this.idAffiliate === 'undefined') {
      this.pageTitle = 'Add new Affiliate';
    } else {
      this.pageTitle = 'Edit Affiliate';
    }

    this.getAffiliateList();
    this.buildForm();
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/affiliate/addaffiliate/addaffiliate.component.ts